import * as React from 'react';

/** Material UI Packages. */
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { Tooltip } from '@mui/material';

/** Material UI Icons. */
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

const ACTION_BUTTON_SX = {
    bgcolor: '#003a52',
    color: 'white',
    '&:hover': { color: '#003a52' },
    p: '5px',
};

export const getItemColumns = ({ onView, onDelete }) => {
    return [
        { field: 'id', headerName: 'ID', flex: 0.2 },
        {
            field: 'il_trade_partner',
            headerName: 'Client',
            headerAlign: 'center',
            align: 'center',
            flex: 0.5,
            renderCell: (params) => {
                return params.value.name || '';
            },
        },
        {
            field: 'il_duty_item_category',
            headerName: 'Category',
            headerAlign: 'center',
            align: 'center',
            flex: 0.5,
            renderCell: (params) => {
                return params.value.category_name || '';
            },
        },
        { field: 'item_code', headerName: 'Item Code', headerAlign: 'center', align: 'center', flex: 0.5 },
        { field: 'item_name', headerName: 'Item Name', headerAlign: 'center', align: 'center', flex: 1.2 },
        { field: 'description', headerName: 'Description', headerAlign: 'center', align: 'center', flex: 0.8 },
        {
            field: 'tier_required',
            headerName: 'Tier',
            headerAlign: 'center',
            align: 'center',
            flex: 0.3,
            type: 'boolean',
            valueFormatter: (value) => (value ? 'Required' : ''),
            renderCell: (params) => (params.value ? 'Required' : ''),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.2,
            type: 'actions',
            headerAlign: 'center',
            align: 'center',
            getActions: ({ row }) => [
                <Tooltip title="View" arrow placement="top">
                    <GridActionsCellItem
                        key="view"
                        sx={ACTION_BUTTON_SX}
                        icon={<VisibilityIcon sx={{ fontSize: '13px' }} />}
                        label="View"
                        onClick={() => onView?.(row.id)}
                    />
                </Tooltip>,
                <Tooltip title="Delete" arrow placement="top">
                    <GridActionsCellItem
                        key="delete"
                        sx={ACTION_BUTTON_SX}
                        icon={<DeleteIcon sx={{ fontSize: '13px' }} />}
                        label="Delete"
                        onClick={() => onDelete?.(row.id)}
                    />
                </Tooltip>,
            ],
        },
    ];
};

export const getFormulaColumns = ({ onDelete }) => {
    return [
        { field: 'id', headerName: 'ID', flex: 0.2 },
        {
            field: 'duty_name',
            headerName: 'Duty Name',
            headerAlign: 'center',
            align: 'center',
            flex: 0.3,
            editable: true,
        },
        { field: 'formula', headerName: 'Formula', headerAlign: 'center', align: 'center', flex: 1, editable: true },
        {
            field: 'description',
            headerName: ' Description',
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            editable: true,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.2,
            type: 'actions',
            headerAlign: 'center',
            align: 'center',
            getActions: ({ row }) => [
                <Tooltip title="Delete" arrow placement="top">
                    <GridActionsCellItem
                        key="delete"
                        sx={ACTION_BUTTON_SX}
                        icon={<DeleteIcon sx={{ fontSize: '13px' }} />}
                        label="Delete"
                        onClick={() => onDelete?.(row.id)}
                    />
                </Tooltip>,
            ],
        },
    ];
};
